import { ErrorMessage } from "components/shared/ErrorMessage";
import { ChangeLicensingPasswordError } from "generatedQueries/changePasswordMutation.graphql";
import React, { FC } from "react";
import { MessageDescriptor } from "react-intl";
import { WarningMessage } from "shared/components/WarningMessage";
import { mapMessages } from "shared/mapMessages";
import { messages as passwordStrengthMessages } from "shared/validations/validations";

export const messages = mapMessages("components.user.changePassword", {
    passwordIncorrectError: "The old password entered is incorrect, please enter the correct password before proceeding.",
    unhandledErrorMessage: "An unhandled error occurred while changing your password. Please check the details entered and try again.",
});

interface IProps {
    error: boolean | ChangeLicensingPasswordError;
    passwordStrengthError: MessageDescriptor | string | undefined;
}

export const ChangePasswordError: FC<IProps> = ({
    error,
    passwordStrengthError,
}) => {
    if (!error) {
        return null;
    }

    if (error === "NEWPASSWORDINVALID") {
        return <WarningMessage message={passwordStrengthError ?? passwordStrengthMessages.defaultPasswordStrengthError} />;
    }

    if (error === "OLDPASSWORDINVALID") {
        return <WarningMessage message={messages.passwordIncorrectError} />;
    }

    return <ErrorMessage message={messages.unhandledErrorMessage} />;
};
